import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Checkbox,
  FormLabel,
  useToast,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Select,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import EditQuickBillModal from "./quickBillEditModal";
import { set } from "lodash";
import { numberToWords } from "../utils/numberToWords";
import Cookie from "js-cookie";
import QuickBillPrintModal from "./quickBillPrintModal";
import ServerTipModal from "./serverTipModal";

const QuickBillData = () => {
  const {
    isOpen: isTipOpen,
    onOpen: onTipOpen,
    onClose: onTipClose,
  } = useDisclosure();
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const {
    isOpen: isPrintOpen,
    onOpen: onPrintOpen,
    onClose: onPrintClose,
  } = useDisclosure();

  const cancelRef = useRef();
  const [isOpen1, setIsOpen] = useState(false);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [editItemId, setEditItemId] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [printData, setPrintData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBills, setSelectedBills] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const customerId = localStorage.getItem("customerId");
  const componentRef = useRef();
  const handlePrint1 = useReactToPrint({
    content: () => componentRef.current,
  });
  const handlePrintModal = () => {
    onPrintOpen();
  };
  const token = Cookie.get("token");

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getQuickBillDataByDate/${customerId}?startDate=${startDate}&endDate=${endDate}`
      );

      const updatedOrders = response.data.quickBill.map((order) => ({
        ...order,
        tax: Math.round(order.cgst + order.sgst), // 👈 add tax field
      }));

      setData(updatedOrders);
      setFilteredData(updatedOrders);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };

  const dueData = async () => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getDueBill/${customerId}?startDate=${startDate}&endDate=${endDate}`
      );

      const updatedOrders = response.data.quickBill.map((order) => ({
        ...order,
        tax: Math.round(order.cgst + order.sgst),
      }));

      setData(updatedOrders);
      setFilteredData(updatedOrders);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while fetching data.");
      }
    }
  };

  const ncData = async () => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getNcBill/${customerId}?startDate=${startDate}&endDate=${endDate}`
      );

      const updatedOrders = response.data.quickBill.map((order) => ({
        ...order,
        tax: Math.round(order.cgst + order.sgst),
      }));

      setData(updatedOrders);
      setFilteredData(updatedOrders);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while fetching data.");
      }
    }
  };

  const fetchEditData = async (id) => {
    try {
      console.log("Fetching bill with ID:", id); // Log the ID being fetched

      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getQuickBillData/${customerId}/${id}`
      );

      console.log("Full API response:", response);
      console.log("Quick bill data:", response.data.quickBill); // Log specific part of response

      setEditData(response.data.quickBill);
      setEditItemId(id);
      onEditOpen();
    } catch (error) {
      console.error("Error fetching bill data:", error); // Log full error
      toast.error("No Bill found By this specific Id");
    }
  };

  const fetchTipData = async (id) => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getQuickBillData/${customerId}/${id}`
      );
      setEditData(response.data.quickBill);
      setEditItemId(id);
      onTipOpen();
    } catch (error) {
      toast.error("No Bill found By this specific Id");
    }
  };

  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getPrintData/${customerId}`
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.rcb.tdrsoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              }
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        })
      );
      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handlePayment = async (id) => {
    try {
      const response = await axios.put(
        `https://api.rcb.tdrsoftware.in/api/updatePayment/${customerId}/${id}`
      );
      alert(response.data.message);
      window.location.reload("/quickBillData");
    } catch (error) {
      toast.error(error);
    }
  };
  const itemsPerPage = 100; // or any number you prefer
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);
  useEffect(() => {
    // fetchData();
    fetchData3();
  }, [customerId]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
    filterData(searchTerm, event.target.value, endDate);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
    filterData(searchTerm, startDate, event.target.value);
  };

  const filterData = (term, start, end) => {
    let filtered = data.filter((order) => {
      const orderDate = new Date(order.createdAt).getTime();
      const startFilter = start ? new Date(start).getTime() : null;
      const endFilter = end ? new Date(end).getTime() : null;

      if (!term && !startFilter && !endFilter) {
        return true; // No filters applied, return all data
      }

      const matchesTerm = term
        ? order.name.toLowerCase().includes(term.toLowerCase()) ||
          order.phoneNo.includes(term) // Include phone number in search
        : true; // If no term, treat it as true

      const withinDateRange =
        (!startFilter || orderDate >= startFilter) &&
        (!endFilter || orderDate <= endFilter);

      return matchesTerm || !term; // If no term, skip term filtering, only use date range
    });

    setFilteredData(filtered);
  };
  const handleEdit = (itemId) => {
    setEditItemId(itemId);
    fetchEditData();
    onEditOpen();
  };
  const handleCheckboxChange = (billId, checked) => {
    if (checked) {
      setSelectedBills((prev) => [...prev, billId]);
    } else {
      setSelectedBills((prev) => prev.filter((id) => id !== billId));
    }
  };
  const handlePrint = (order) => {
    let total = numberToWords(
      order.gst === false
        ? order.foodItem.reduce((acc, item) => acc + item.price, 0) * 0.05 +
            order.wineItem.reduce((acc, item) => acc + item.price, 0) +
            order.foodItem.reduce((acc, item) => acc + item.price, 0)
        : order.wineItem.reduce((acc, item) => acc + item.price, 0) +
            order.foodItem.reduce((acc, item) => acc + item.price, 0)
    );
    const content = `
    <html>
      <head>
       <style>
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0.2in;
    width: 3in;
   
   
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 10px;
  }
    @page{size: 3in auto; 
            margin: 1;
            margin-bottom: 10;
            padding:1
}
  th, td {
    border-bottom: 1px dashed black;
    text-align: left;
    padding: 2px;
    font-size: 10px;
  }
  th {
    background-color: #f2f2f2;
  }
  h4, h5 {
    text-align: center;
    margin: 4px 0;
    font-size: 12px;
  }
  .center {
    text-align: center;
    margin-bottom: 10px;
  }
  .footer {
    text-align: right;
    margin-top: 10px;
    font-size: 12px;
  }
  .left {
    font-size: 10px;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    border-bottom: 1px dashed black;
  }
  .Grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 7px;
    place-items: center;
  }
  .summary {
    margin-top: 10px;
    font-size: 12px;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    border-bottom: 1px dashed black;
    padding: 6px;
  }
  img {
    width: 90px;
    height: 60px;
    border-radius: 8px;
    display: block;
    margin: 0 auto;
  }
  @media print {
    body {
      margin: 0;
      padding: 0;
    }
    table, .center, .summary, .footer {
      page-break-inside: avoid;
    }
  }
</style>
      </head>
      <body>
        ${printData
          .map(
            (item) => `
          <div class="center">
            <h4>Cash Memo</h4>
            <img src="${item.imageUrl}" alt="Logo" />
            <h4><b>${item.name}</b></h4>
            <h5>${item.adress}</h5>
            <h5>Phone: ${item.phoneNo}</h5>
            <h5>${item.website}</h5>
            ${item.gstNo ? `<h5>GST No: ${item.gstNo}</h5>` : ""}
            ${item.fssaiNo ? `<h5>FSSAI No: ${item.fssaiNo}</h5>` : ""}
          </div>
        `
          )
          .join("")}
        <div class="Grid">
        <h4>Table:${order.tableNo}</h4>
        <h4>Bill:${order.billNo}</h4>
        
        
        
        </div>
        <div>
        <h4>Date:${new Date(order.createdAt).toLocaleString("en-GB")}</h4>
        </div>
        
        ${
          order.wineItem.length > 0
            ? `
          <h4 class="center"># Wine Items #</h4>
          <table>
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Rate</th>
                <th>Qty</th>
                
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              ${order.wineItem
                .map(
                  (item) => `
                <tr>
                  <td>${item.name}</td>
                  <td>${(item.price / item.quantity).toFixed(2)}</td>
                  <td>${item.quantity}</td>
                  
                  <td>${item.price}</td>
                </tr>
              `
                )
                .join("")}
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="footer">Gross Total: ${order.wineItem.reduce(
                  (acc, item) => acc + item.price,
                  0
                )}</td>
              </tr>
              <tr>
                <td colspan="5" class="footer">Drinks Total: ${order.wineItem.reduce(
                  (acc, item) => acc + item.price,
                  0
                )}</td>
              </tr>
            </tfoot>
          </table>
        `
            : ""
        }

         <h4 class="center"># Food Items #</h4>
  <table>
    <thead>
      <tr>
        <th>Item Name</th>
        ${order.cgst > 0 ? `<th>Hsn/Sac</th>` : ""}
        <th>Rate</th>
        <th>Qty</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      ${order.foodItem
        .map(
          (item) => `
        <tr>
          <td>${item.name}</td>
          ${order.cgst > 0 ? `<td>${item.hsnNo || ""}</td>` : ""}
          <td>${(item.price / item.quantity).toFixed(2)}</td>
          <td>${item.quantity}</td>
          <td>${item.price.toFixed(2)}</td>
        </tr>
      `
        )
        .join("")}
    </tbody>
    <tfoot>
      <tr>
        <td colspan="5" class="footer">
          Gross Total: ₹${order.foodItem
            .reduce((acc, item) => acc + item.price, 0)
            .toFixed(2)}
        </td>
      </tr>
      <tr>
        <td colspan="5" class="footer">
          Add  CGST on Gross: ₹${
            order.cgst > 0 ? order.cgst.toFixed(2) : "0.00"
          }
        </td>
      </tr>
      <tr>
        <td colspan="5" class="footer">
          Add  SGST on Gross: ₹${
            order.cgst > 0 ? order.sgst.toFixed(2) : "0.00"
          }
        </td>
      </tr>
      <tr>
        <td colspan="5" class="footer">
          5% Total GST: ₹${
            order.cgst > 0 ? (order.cgst + order.sgst).toFixed(2) : "0.00"
          }
        </td>
      </tr>
      <tr>
        <td colspan="5" class="footer">
          Food Total: ₹${
            order.cgst > 0
              ? (
                  order.cgst * 2 +
                  order.foodItem.reduce((acc, item) => acc + item.price, 0)
                ).toFixed(2)
              : order.foodItem
                  .reduce((acc, item) => acc + item.price, 0)
                  .toFixed(2)
          }
        </td>
      </tr>
    </tfoot>
  </table>
        <div class="summary">
        <h4 class="center">Net Gross Total Amount ${
          order.wineItem.reduce((acc, item) => acc + item.price, 0) +
          order.foodItem.reduce((acc, item) => acc + item.price, 0)
        }</h4>
        <h4 class="center">5% GST Total ${
          order.cgst > 0 ? order.cgst * 2 : 0
        }</h4>
       ${
         order.discountPercentage
           ? `<h4 class="center">Discount Precentage-${order.discountPercentage}</h4>`
           : ""
       }
       ${
         order.discount
           ? `<h4 class="center">Discount-${order.discount}</h4>`
           : ""
       }

       ${
         order.cgst > 0
           ? ` <h5 class="center">Roundoff- ${
               parseInt(order.totalBilling) -
               (parseInt(
                 order.wineItem.reduce((acc, item) => acc + item.price, 0)
               ) +
                 parseInt(
                   order.foodItem.reduce((acc, item) => acc + item.price, 0)
                 ) +
                 order.cgst * 2)
             }</h5>`
           : ""
       }
       
        <h4 class="center">Total Amount ${order.totalBilling}</h4>
       
          

        </div>
        <div class='left'>
        <h4 >Total Amount (INR in words): ${total}</h4>
        </div>
        
       ${order.cash ? `<h4 class="center">Cash : ${order.cash}</h4>` : ""}
       ${
         order.online
           ? `<h4 class="center">${order.mode} : ${order.online}</h4>`
           : ""
       }

        <div class="footer">
        <h5>Thank you</h5>
        <h5>Visit Again</h5>
        </div>

        <script>
          window.onload = () => window.print();
        </script>
      </body>
    </html>
  `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(content);
    printWindow.document.close();
  };

  const exportToExcel = () => {
    const cleanedData = filteredData.map((order) => {
      // Extract Food and Wine totals separately
      const foodAmount = order.foodItem?.reduce(
        (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
        0
      );

      const wineAmount = order.wineItem?.reduce(
        (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
        0
      );

      // Example tax fields (replace with your actual values from API/db)
      const cgst = order.cgst || 0;
      const sgst = order.sgst || 0;
      const discount = order.discountPercentage || 0;
      const roundOff = order.roundOff || 0;

      // Gross Bill before discount/roundoff
      const billAmount = (foodAmount || 0) + (wineAmount || 0) + cgst + sgst;

      // Net amount after adjustments
      const netAmount = billAmount - discount + roundOff;

      return {
        Date: new Date(order.createdAt).toLocaleDateString("en-GB"),
        BillNo: order.billNo,
        BillAmount: billAmount,
        FoodAmount: foodAmount,
        WineAmount: wineAmount,
        CGST: cgst,
        SGST: sgst,
        "Discount(%)": discount,
        RoundOff: roundOff,
        NetAmount: netAmount,
      };
    });

    // Create worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bill Report");

    // Save as file
    XLSX.writeFile(workbook, `${startDate}-${endDate}-BillData.xlsx`);
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.rcb.tdrsoftware.in/api/deleteQuickBill/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message);
      setIsOpen(false);
      fetchData();
    } catch (error) {
      if (error.response.status === 403) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
      }
    }
  };
  const openModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };
  const grandTotal = currentItems.reduce(
    (sum, order) => sum + (order.totalBilling || 0),
    0
  );

  return (
    <Box>
      <Box
        mb={4}
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
        mt={2}
      >
        <Input
          w="30%"
          type="text"
          placeholder="Search by Name or Phone"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <Input
          w="20%"
          type="date"
          placeholder="Start Date"
          value={startDate}
          onChange={handleStartDateChange}
          mr={2}
        />
        <Input
          w="20%"
          type="date"
          placeholder="End Date"
          value={endDate}
          onChange={handleEndDateChange}
          mr={2}
        />
        <Input
          w="20%"
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          bg="red.400"
          color="white"
          _hover={{ bg: "red.200" }}
          _focus={{ bg: "white.300" }}
        />

        <Button
          colorScheme="blue"
          onClick={async () => {
            try {
              if (!selectedBills.length) {
                toast.error("Please select at least one bill");
                return;
              }
              if (!selectedDate) {
                toast.error("Please select a date");
                return;
              }

              const response = await axios.put(
                `https://api.rcb.tdrsoftware.in/api/updateBillsDate/${customerId}`,
                {
                  billIds: selectedBills,
                  newDate: selectedDate,
                }
              );

              toast.success(response.data.message);
              fetchData(); // refresh list
            } catch (error) {
              toast.error(error.response?.data?.message || "Update failed");
            }
          }}
        >
          Bill Update
        </Button>
        <Button colorScheme="green" onClick={dueData}>
          Due Bill
        </Button>
        <Button colorScheme="yellow" onClick={ncData}>
          Nc Bill
        </Button>
        <Button colorScheme="blue" onClick={handlePrintModal}>
          Print
        </Button>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <Button colorScheme="blue" onClick={exportToExcel} p={2} mb={5}>
          Export to Excel File
        </Button>
      </Box>

      <EditQuickBillModal
        data={editData}
        onOpen={onEditOpen}
        onClose={onEditClose}
        isOpen={isEditOpen}
        customerId={customerId}
        setSelectId={setEditItemId}
        id={editItemId}
      />
      <ServerTipModal
        data={editData}
        onOpen={onTipOpen}
        onClose={onTipClose}
        isOpen={isTipOpen}
        customerId={customerId}
        setSelectId={setEditItemId}
        id={editItemId}
      />
      <TableContainer width="full">
        <Table size="sm" variant="striped" colorScheme="green">
          <TableCaption>Quick Bill Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Food Item</Th>
              <Th>Wine Item</Th>
              <Th>Name</Th>
              <Th>Phone No</Th>
              <Th>Bill No</Th>
              <Th>Table No</Th>

              <Th>Total Bill</Th>
              <Th>GST</Th>

              <Th>Discount</Th>
              <Th>Discount%</Th>
              <Th>Happy Discount%</Th>
              <Th>Wine Discount%</Th>
              <Th>Food Discount%</Th>
              <Th>Complementary</Th>
              <Th>GrossAmount</Th>

              <Th>Cash</Th>
              <Th>Card</Th>
              <Th>Mode</Th>
              <Th>Online</Th>
              <Th>Due</Th>

              <Th>Created At</Th>
              <Th>Server Name</Th>
              <Th>Tip</Th>
              <Th>Select</Th>

              <Th>Print</Th>
              <Th>Edit</Th>
              <Th>Tip Add</Th>
              <Th>Delete</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentItems.map((order, index) => (
              <Tr key={index}>
                <Td>
                  <Table size="xsm" variant="striped" colorScheme="orange">
                    <Thead>
                      <Tr gap={2}>
                        <Td px={2}>Name</Td>
                        {order.cgst > 0 ? <Td px={2}>HsnNo</Td> : ""}
                        <Td px={2}>Qty</Td>
                        <Td px={2}>Price</Td>
                        <Td px={2}>Sgst Amt</Td>
                        <Td px={2}>Cgst Amt</Td>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {order.foodItem.map((item, index) => (
                        <Tr>
                          <Td px={2}>{item.name}</Td>
                          {order.cgst > 0 ? <Td px={2}>{item.hsnNo}</Td> : ""}
                          <Td px={2}>{item.quantity}</Td>
                          <Td px={2}>{item.price}</Td>
                          <Td px={2}>{item.sgst?.toFixed(1)}</Td>
                          <Td px={2}>{item.cgst?.toFixed(1)}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Td>
                <Td>
                  <Table size="xsm" variant="striped" colorScheme="yellow">
                    <Thead>
                      <Tr>
                        <Td>Name</Td>
                        <Td>Qty</Td>
                        <Td>Price</Td>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {order.wineItem.map((item, index) => (
                        <Tr>
                          <Td>{item.name}</Td>
                          <Td>{item.quantity}</Td>
                          <Td>{item.price}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Td>
                <Td>{order.name}</Td>
                <Td>{order.phoneNo}</Td>
                <Td>{order.billNo}</Td>
                <Td>{order.tableNo}</Td>

                <Td>{order.totalBilling}</Td>
                <Td>{order.tax}</Td>
                <Td>{order.discount}</Td>

                <Td>{order.discountPercentage}</Td>
                <Td>
                  {order.happyHourDiscountPercentage > 0
                    ? order.happyHourDiscountPercentage
                    : null}
                </Td>
                <Td>{order.wineDiscount}</Td>
                <Td>{order.foodDiscount}</Td>
                <Td>{order.isComplementary ? "Yes" : "No"}</Td>

                <Td>{order.grossAmount}</Td>
                <Td>{order.cash}</Td>
                <Td>{order.card}</Td>
                <Td>{order.mode}</Td>
                <Td>{order.online}</Td>
                <Td>{order.due}</Td>

                {/* <Td>{order.status ? "Due" : "Paid"}</Td>
                <Td onClick={()=>handlePayment(order._id)}> <Button colorScheme='green'  onClick={()=>handlePayment(order._id)}>Change</Button></Td> */}
                <Td>{new Date(order.createdAt).toLocaleString("en-GB")}</Td>
                <Td>{order.server}</Td>

                <Td>{order.serverTip}</Td>
                <Td>
                  <Checkbox
                    isChecked={selectedBills.includes(order._id)}
                    onChange={(e) =>
                      handleCheckboxChange(order._id, e.target.checked)
                    }
                    borderColor="red.500"
                    _hover={{ borderColor: "red.600" }}
                    _checked={{ borderColor: "red.500", bg: "red.100" }}
                  />
                </Td>

                <Td>
                  <Button
                    colorScheme="blue"
                    size="sm"
                    onClick={() => handlePrint(order)}
                  >
                    Print
                  </Button>
                </Td>

                <Td>
                  <Button
                    colorScheme="green"
                    onClick={() => fetchEditData(order._id)}
                  >
                    Edit
                  </Button>
                </Td>
                <Td>
                  <Button
                    colorScheme="green"
                    onClick={() => fetchTipData(order._id)}
                  >
                    Tip Add
                  </Button>
                </Td>
                <Td>
                  <Button
                    colorScheme="red"
                    onClick={() => openModal(order._id)}
                  >
                    Delete
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>

        <Box mt={4} textAlign="center" fontWeight="bold" fontSize="lg">
          Grand Total Bill: ₹{grandTotal.toFixed(2)}
        </Box>
      </TableContainer>
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <QuickBillPrintModal
        isOpen={isPrintOpen}
        onOpen={onPrintOpen}
        onClose={onPrintClose}
        data={printData}
        quickBillData={filteredData}
      />
      <Box display="flex" justifyContent="center" mt={4}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
          mr={2}
        >
          Prev
        </Button>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            onClick={() => handlePageChange(i + 1)}
            variant={currentPage === i + 1 ? "solid" : "outline"}
            mx={1}
          >
            {i + 1}
          </Button>
        ))}
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
          ml={2}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default QuickBillData;
